import React, { forwardRef, ElementType } from "react";
import classNames from "classnames";

export function styledMod<TTag extends ElementType>(
  tag: TTag,
  baseClassName: string
) {
  type Props = React.ComponentPropsWithoutRef<TTag> & { className?: string };
  type Ref   = React.ElementRef<TTag>;

  return forwardRef<Ref, Props>(function StyledFixed(
    { className, ...rest }, ref
  ) {
    return React.createElement(tag, {
      ref,
      className: classNames(baseClassName, className),
      ...rest,
    });
  });
}
